/**
 * Публичные страницы приложения — доступны БЕЗ авторизации: auth-страницы (в т.ч.
 * приходящие по ссылкам из писем verify-email / reset-password), SSO-callback и
 * гостевые поверхности событий/опросов.
 *
 * Назначение (SSOT): глобальные 401-интерсепторы (http-client.ts, services/api.ts,
 * services/api/api.ts) НЕ должны уводить пользователя с этих страниц на /auth/login.
 * 401 на бутстрапе — ШТАТНАЯ ситуация для гостя: протухший accessToken в хранилище →
 * /auth/me → 401 → раньше жёсткий window.location на логин сносил публичную страницу.
 *
 * Прецедент 2026-07-16: клик по ссылке сброса пароля из письма показывал форму на
 * пару секунд и переадресовывал на страницу входа (бутстрап-401 → редирект).
 *
 * При добавлении нового публичного роута в App.tsx — добавить паттерн сюда.
 */
const PUBLIC_PATH_PATTERNS: RegExp[] = [
  /^\/auth(\/|$)/, // login/register/verify-email/forgot-password/reset-password
  /^\/(login|register|forgot-password)$/, // top-level редиректы на /auth/*
  /^\/sso\/callback/, // SSO-callback (приём токенов от IdP)
  /^\/join\//, // гостевое присоединение по токену
  /^\/surveys\/[^/]+\/respond/, // публичный ответ на опрос по токену
  /^\/events\/[^/]+\/(join|invite)$/, // гостевые join/invite события
  /^\/(terms-of-service|privacy-policy|sub-processors)$/, // юридические документы
];

/** true — страница публичная: 401-редирект на логин с неё запрещён. */
export function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATH_PATTERNS.some((pattern) => pattern.test(pathname));
}
